import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22 12c.027-2.29-1.105-4.09-3-6-1.926-1.914-3.652-2.988-6-2.988-.066-.004-3.7-.313-7 2.988-2.09 2.09-3 4.14-3 7 0 2.207.98 4.988.984 5 .512 1.066-.18 2.484.164 2.84.004 0 .008.004.008.004.004.004.004.008.008.008.078.078.203.101.367.101.367 0 .918-.133 1.485-.133.332 0 .671.047.984.196.266.129 2.957.984 5 .984 2.902 0 4.852-.852 7-3 3.191-3.191 3-7 3-7Zm-9-7c1.082 0 2.73.73 4 2l1 1c1.395 1.395 2 2.918 2 4 0 0 .063 1.531-.344 2.04-.918-1.173-1.91-1.325-3.027-.767 0-2.074-1.992-2.437-2.418-2.421L14 11c.02-.426-.133-2.566-2.203-2.566.57-1.149.46-2.164-.793-3.106C11.688 4.965 13 5 13 5Z" }, null, -1)
  ])))
}
export default { render: render }